import React, {FC, ReactElement, useContext} from 'react';
import {ViewIdentifiable} from "../../models/common/ViewSettings";
import {LanguageProp} from "../../config/LanguageConfig";
import { Tooltip, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import {LanguageContext} from "../../config/ContextConfig";
import {Logo} from "../icons/Logo";
import {TextDisplay} from "../common/data-display/TextDisplay";

export interface ViewTitleDisplayProps extends  Partial<LanguageProp> {
    title: string | ReactElement
}

export function ViewTitleDisplay({ title, language }: ViewTitleDisplayProps) {

    const lang = useContext( LanguageContext );

    return (
        <Tooltip title={language?.common?.backToHome?.tooltipText ?? lang.common.backToHome.tooltipText}>
            <div className="flex items-center gap-10">
                <Logo className="text-white" />
                <TextDisplay variant="h5">
                    <Link to="/" style={{ color: "white" }}>
                        { title }
                    </Link>
                </TextDisplay>
            </div>
        </Tooltip>
    );
}